export default "__VITE_ASSET__j2KMR8Wu__"